<template>
  <div>
    <ui-dialog heading="Vorlagen" @cancel="$emit('cancel')">
      <div class="-mb-2 text-medium">
        <slot>
          <p class="mb-4 text-sm text-gray-700">
            <span v-if="folderTemplates.length > 0">
              Bitte wählen Sie hier eine Vorlage für Ihr Dossier aus:
            </span>
            <span v-else> Es wurden keine Vorlagen gefunden. </span>
          </p>

          <div
            v-for="template in folderTemplates"
            :key="`template-${template.id}`"
          >
            <label>
              <input
                type="radio"
                :value="template.id"
                v-model="chosenId"
                class="-mb-1 appearance-none border-2 border-blue h-5 mr-2 rounded-full w-5"
              />
              {{ template.name }}
            </label>
          </div>
        </slot>
      </div>
      <template slot="footer">
        <ui-button @click.native="$emit('cancel')" tertiary>
          Abbrechen
        </ui-button>
        <ui-button
          :disabled="chosenId === null"
          @click.native="submit"
          data-test="submit"
        >
          Vorlage anwenden
        </ui-button>
      </template>
    </ui-dialog>
  </div>
</template>
<script>
import UiButton from "./UiButton.vue";
import UiDialog from "./UiDialog.vue";
import Vue from "vue";

export default Vue.extend({
  components: {
    UiButton,
    UiDialog
  },
  props: {
    folderTemplates: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chosenId: null
    };
  },
  methods: {
    submit() {
      if (this.chosenId) {
        this.$emit("submit", this.chosenId);
      }
    }
  }
});
</script>
<style scoped>
/**
 * Workaround for the missing :checked selector in tailwind. This can be
 * done in tailwind after this PR is merged:
 * https://github.com/tailwindcss/tailwindcss/pull/1285
 */
input[type="radio"]:checked:after {
  border-color: inherit;
  border-radius: 50%;
  border-style: solid;
  border-width: 4px;
  content: "";
  display: block;
  height: 8px;
  margin-left: 4px;
  margin-top: 4px;
  width: 8px;
}
</style>
